module.exports = __webpack_public_path__ + "img/tele-handler.c146783.png";